/**
 * Created by Rodrigo Quesada on 24/01/17.
 */
import {Model} from '../../common/model.class';
import ProjectionInformation = Model.ProjectionInformation;

export const CompletedInUSAProjection = new ProjectionInformation('completedInUSA');



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/education/medical/medical-education.projections.ts